/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../axiosApi';

export interface IListagemUsuarios {
    iduser: string;
    nome: string;
    login: string;
    status: boolean;
    urlimg: string;
}
export interface IDetalhesUsuarios {
  nome: string;
  login: string;
  senha: string;
  idempresa: string;
  urlimg: string;
  vendedor: boolean;
  nivelacesso: number;
}
export interface IUpdateUsuarios {
  nome: string;
  vendedor: boolean;
  nivelacesso: number; 
}
export interface IGetUsuarios {
  nome: string;
  login: string;
  senha: string;
  idempresa: string;
  status: boolean;
  urlimg: string;
}
interface IUpdateSenha {
  nome: string;
  login: string;
  senha: string;
  novasenha: string;
  confirmarsenha: string;
}
export interface ISenha {
  senha: string;
} 
export interface IPermissao {
  idpermissoes: string;
  idusuario: number;
	metodo: string;
	url: string;
	descricao: string;
	permissao: boolean;
} 
type TComTotalCount = {
    data: IListagemUsuarios[];
    totalCount: number;
}
type TComTotalCountPermissao = {
  data: IPermissao[];
  totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}

interface BackendError {
  errors?: {
    default?: string;
  };
}

const getAll = async (page = 1, filter = '', limit = Environment.LIMITE_DE_LINHAS): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/users?page=${page}&limit=${limit}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllList = async (filter = '', id = ''): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/userslist?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}` : `/userslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
  return {
    data: Array.isArray(data) ? data : [data],
    totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
  };
}
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getByIdPerfil = async (id: string): Promise<IGetUsuarios | Error> => {
  try {
    const { data } = await Api.get(`/users/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllPermissao = async (id: string, page = 1, modulo: string, filter = ''): Promise<TComTotalCountPermissao | Error> => {
  try {
    const { data, headers } = await Api.get(`/permissao/${id}?page=${page}&modulo=${modulo}&filter=${filter}&limit=${10}`);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 9),
      };
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: IDetalhesUsuarios): Promise<void | Error> => {
  try {
    const guuid = uuidv4();
    await Api.post('/users', {
      iduser: guuid,
      ...dados
    });
    return; 
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage =
          axiosError.response.data?.errors?.default ||
          'Erro desconhecido';
        return new Error(errorMessage);
      }
      if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      }
      return new Error(axiosError.message);
    }
    return new Error('Erro inesperado');
  }
};
const updateByIdPermissao = async (id: string, permissao: boolean): Promise<void | Error> => {
  try {
    const dados = {idpermissoes: id, permissao: permissao};
    await Api.put(`/permissao/${id}`,  dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }}
};
const updateByIdImg = async (id: string, image: File | undefined, dados: ISenha): Promise<void | Error> => {
  try {
     const payload = {
      ...dados,
      id, // 👈 adiciona aqui
    };
    const { data } = await Api.post<IDetalhesUsuarios>(`/userssenhaavatar`, payload);
    if (data) {
      const formData = new FormData();
      formData.append('file', image || ''); 
      await Api.put(`/usersavatar/${id}`, formData);
      return;
    }
    return new Error('Erro ao Atualizar Foto.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    } }
};
const getById = async (id: string): Promise<IGetUsuarios | Error> => {
  try {
    const { data } = await Api.get(`/users/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    } }
};
const updateById = async (id: string, dados: IUpdateUsuarios): Promise<void | Error> => {
  try {
    await Api.put(`/users/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updatesenha = async (
  id: string,
  dados: IUpdateSenha
): Promise<void | Error> => {
  try {
    await Api.put(`/userssenha/${id}`, dados);
  } catch (error) {

    if (axios.isAxiosError(error)) {
      const data = error.response?.data as BackendError | undefined;

      if (data?.errors?.default) {
        return new Error(data.errors.default); // ✅ AQUI
      }

      if (error.request) {
        return new Error('Nenhuma resposta do servidor');
      }

      return new Error(error.message || 'Erro na requisição');
    }

    return new Error('Erro inesperado');
  }
};


export const UsuarioService = {
  getAll,
  create,
  getAllPermissao,
  updateByIdPermissao,
  updateByIdImg,
  getById,
  updateById,
  updatesenha,
  getByIdPerfil,
  getAllList
};